import React, { useEffect, useState } from 'react';
import './SuccessDialog.css';

const SuccessDialog = ({ isOpen, onClose }) => {
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    if (isOpen) {
      setCountdown(3);
      const interval = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="success-backdrop">
      <div className="success-container">
        <div className="success-icon">
          <svg viewBox="0 0 52 52" className="checkmark">
            <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none" />
            <path className="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
          </svg>
        </div>

        <h2 className="success-title">Tabriklaymiz!</h2>
        <p className="success-message">
          Masterclassga muvaffaqiyatli ro'yxatdan o'tdingiz. Masterclass boshlanishidan oldin sizga eslatma yuboramiz.
        </p>

        <div className="redirect-info">
          <p className="redirect-text">
            Londonliklar.uz Telegram kanaliga yo'naltirilmoqdasiz...
          </p>
          <div className="countdown-circle">
            <span className="countdown-number">{countdown}</span>
          </div>
        </div>

        <button className="close-button" onClick={onClose}>
          Yopish
        </button>
      </div>
    </div>
  );
};

export default SuccessDialog;
